module.exports = __webpack_public_path__ + "assets/img/moon.d13a5c6a.webp";